var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.linkNotFound)?_c('LinkNotFound'):(_vm.packetComplete)?_c('PacketComplete',_vm._b({},'PacketComplete',_vm.packetComplete,false)):_c('div',[_c('ErrorDisplay')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }